import Vuex from 'vuex';
const store = new Vuex.Store({
    state: {
        commonDataReady: false,
    },
});

export default store;
